import BaseAPIService from 'src/services/base/base-api-service';
import AccountClass from 'src/model/account.model';
import env from 'src/shared/env';

class ContactVerificationService extends BaseAPIService<AccountClass> {
  public accountsEndpoint: string = '/accountapp/v1/mobile';
  public emailEndpoint: string = '/accountapp/v1/email';
  public orderPrefencesEndpoint: string = '/accountapp/v1/notifications';
  public getPrefencesEndpoint: string = '/accountapp/v1/notifications';
  constructor() {
    super(AccountClass);
  }

  public generatePhoneOtp(
    userId: string,
    phoneNum: string,
    language:string,
    region:string

  ): Promise<any> {
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'GET',
      params: {
        webuserId: userId,
        mobileNumber: phoneNum,
        lang:language,
        region
      },
      url: `${this.accountsEndpoint}/generateOTP`
    })
      .then(res => {
        return res;
      })
      .catch(error => {
        throw error;
      });
  }

  public validatePhoneOtp(userId: string, receivedOtp: number,userMobile: string,language: string,region: string): Promise<any> {
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'POST',
      params: {
        webuserId: userId,
        mobileOTP: receivedOtp,
        mobileNumber: userMobile,
        lang:language,
        region
      },
      url: `${this.accountsEndpoint}/validateOTP`
    })
      .then(res => {
        return res;
      })
      .catch(error => {
        throw error;
      });
  }

  public generateEmailOtp(
    userId: string,
    email: string,
    language: string,
    region: string
  ): Promise<any> {
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'GET',
      params: {
        webuserId: userId,
        emailId: email,
        lang: language,
        region
      },
      url: `${this.emailEndpoint}/generateOTP`
    })
      .then(res => {
        return res;
      })
      .catch(error => {
        throw error;
      });
  }

  public saveOrderPrefernces(accountId: string,clientIdentity: string, datas:any): Promise<any> {
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'POST',
      data: datas,
      url: `${this.orderPrefencesEndpoint}/updatepreferences/${clientIdentity}/${accountId}`
    })
      .then(res => {
        return res;
      })
      .catch(error => {
        throw error;
      });
  }

  public getpreferences(accountIds: string,clientIdentityval: string
  ): Promise<any> {
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'GET',
      params: {
        clientIdentity: clientIdentityval,
        accountId: accountIds
      },
      url: `${this.getPrefencesEndpoint}/getpreferences/${clientIdentityval}/${accountIds}`
    })
      .then(res => {
        return res;
      })
      .catch(error => {
        throw error;
      });
  }

  public validateEmailOtp(userId: string, receivedOtp: number,userEmail: string, language: string, region:string): Promise<any> {
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'POST',
      params: {
        webuserId: userId,
        otp: receivedOtp,
        emailId: userEmail,
        lang: language,
        region
      },
      url: `${this.emailEndpoint}/validateOTP`
    })
      .then(res => {
        return res;
      })
      .catch(error => {
        throw error;
      });
  }
}



const contactVerificationServiceInstance = new ContactVerificationService();
Object.freeze(contactVerificationServiceInstance);

export default contactVerificationServiceInstance;
